export const txhhs = {
  APP_ERRORS: {
    txhhschip: {
      linkService: {
        caseNumber: 'params.caseNumber',
        zipCode: 'params.zipCode',
      },
    },
  },
};
